import { render } from "./AppWrapper.vue?vue&type=template&id=4464d6de"
import script from "./AppWrapper.vue?vue&type=script&lang=js"
export * from "./AppWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/web.digitalsystemsrl.it/web.digitalsystemsrl.it/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__